import { render } from "./HotelLayout.vue?vue&type=template&id=5bc8ffd8"
import script from "./HotelLayout.vue?vue&type=script&lang=js"
export * from "./HotelLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__